import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpProvider } from '../../common/http/http-provider.service';
import { CEFilterDTO } from '../../../features/construction-element/model/construction-element-test-filter';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class ConstructionElementDataRepository extends HttpProvider {
  constructor(http: HttpClient) {
    super(http);
  }

  
  searchCE(data: CEFilterDTO) {
    return this.post('constructionElement/search/', data);
  }

  
 exportCE(data: CEFilterDTO) {
    return this.getFile<any>('constructionElement/export', data);
  }

  exportCert(data: CEFilterDTO) {
    return this.getFile<any>('constructionElement/exportCert', data);
  }

  exportTestCert(data: CEFilterDTO) {
    return this.getFile<any>('constructionElement/exportTestCert', data);
  }

  
  getSearchCECert(data: CEFilterDTO) {
    return this.post('constructionElement/searchCert/', data);
  }

  getSearchCETestCert(data: CEFilterDTO) {
    return this.post('constructionElement/searchTestCert/', data);
  }

  
}